import React from "react";
import "./AdditionalDetails.css";
import { toast } from "react-toastify";
import { DownloadFile } from "../../../../utils/downloadFile";

const AdditionalDetails = ({ transporter_data = {} }) => {
  const documents = transporter_data.additional_attachments || [];

  const handleFileDownload = async (file) => {
    if (!file?.blob_url) {
      toast.info("No file uploaded");
      return;
    }

    try {
      await DownloadFile(
        file.blob_url,
        (loading) => console.log("Downloading...", loading),
        file.name || "Document.pdf"
      );
    } catch (error) {
      console.error("Download failed:", error);
      toast.error("Failed to download file");
    }
  };

  // Handle empty or missing documents gracefully
  if (!documents.length || documents.every((d) => !d?.blob_url)) {
    return (
      <div className="othercard">
        <div className="othercontainer row">
          <div className="col-12">
            <h3 className="data_header">Additional Details</h3>
            <p>Details not available</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="othercard">
      <div className="othercontainer row">
        <div className="col-12">
          <h3 className="data_header">Additional Details</h3>
        </div>

        {documents.map((document, index) => (
          <div
            key={index}
            className="d-flex justify-content-between align-items-center my-2"
          >
            <p className="mb-0">{document.name || "Untitled Document"}</p>
            <button
              className="btn btn-light"
              title="Download"
              onClick={() => handleFileDownload(document)}
            >
              <i className="fas fa-file-download"></i>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdditionalDetails;
